import { graphql } from "../generated";

export const MUTATE_CLEAR_NOTIFICATIONS = graphql(`
  mutation ClearNotifications {
    clearNotifications {
      id
    }
  }
`);
